/*******************************************************************************
 * Project：
 * Summary:
 *　　 User state
 * Remarks:
 *    Define state for User
 * History：
 *    ThaiTV            2021/07/28    Create
 ******************************************************************************/
import { IMstHTOrg } from '../../models/mstHTOrg.interface';
export interface IMstHTOrgState {
    selectedIMstHTOrg: IMstHTOrg;
}

export const initialMstHTOrgState: IMstHTOrgState = {
    selectedIMstHTOrg: null,
};

